(function() {
  const canvas = document.getElementById('lc-dna-canvas');
  const ctx = canvas.getContext('2d');

  function resize() {
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
  }
  
  window.addEventListener('resize', resize);

  const GOLD  = 'rgba(183,148,84,';
  const WHITE = 'rgba(255,255,255,';
  let t = 0;

  function draw() {
    const W = canvas.width, H = canvas.height;
    ctx.clearRect(0, 0, W, H);

    const cx   = W / 2;
    const amp  = W * 0.22;
    const freq = 0.018;
    const speed = 0.002;
    const rungs = 28;

    // Strands
    for (let i = 0; i <= 300; i++) {
      const y     = (i / 300) * H;
      const phase = y * freq - t;
      const x1    = cx + Math.sin(phase) * amp;
      const x2    = cx + Math.sin(phase + Math.PI) * amp;
      const d1    = (Math.sin(phase) + 1) / 2;
      const d2    = (Math.sin(phase + Math.PI) + 1) / 2;

      ctx.beginPath();
      ctx.arc(x1, y, 1.2, 0, Math.PI * 2);
      ctx.fillStyle = GOLD + (0.15 + d1 * 0.35) + ')';
      ctx.fill();

      ctx.beginPath();
      ctx.arc(x2, y, 1.2, 0, Math.PI * 2);
      ctx.fillStyle = WHITE + (0.08 + d2 * 0.2) + ')';
      ctx.fill();
    }

    // Rungs (base pairs)
    for (let r = 0; r < rungs; r++) {
      const y     = (r / rungs) * H + (H / rungs) * 0.5;
      const phase = y * freq - t;
      const x1    = cx + Math.sin(phase) * amp;
      const x2    = cx + Math.sin(phase + Math.PI) * amp;
      const alpha = Math.abs(Math.sin(phase)) * 0.18;

      if (alpha < 0.01) continue;

      ctx.beginPath();
      ctx.moveTo(x1, y);
      ctx.lineTo(x2, y);
      const grad = ctx.createLinearGradient(x1, y, x2, y);
      grad.addColorStop(0,   GOLD  + alpha + ')');
      grad.addColorStop(0.5, WHITE + (alpha * 0.8) + ')');
      grad.addColorStop(1,   GOLD  + alpha + ')');
      ctx.strokeStyle = grad;
      ctx.lineWidth = 0.8;
      ctx.stroke();

      ctx.beginPath();
      ctx.arc(x1, y, 1.5, 0, Math.PI * 2);
      ctx.fillStyle = GOLD + (alpha * 1.4) + ')';
      ctx.fill();

      ctx.beginPath();
      ctx.arc(x2, y, 1.5, 0, Math.PI * 2);
      ctx.fillStyle = GOLD + (alpha * 1.4) + ')';
      ctx.fill();
    }

    t += speed;
    requestAnimationFrame(draw);
  }

  draw();
  resize();
})();